import type { TOC } from '@ember/component/template-only';
import { eq } from 'tio-ui/utilities';
import onClickOutside from 'ember-click-outside/modifiers/on-click-outside';
import { Button } from 'tio-ui/components/buttons';
import { on } from '@ember/modifier';
import { PhDotsThreeVertical } from 'ember-phosphor-icons';

interface TioQuicklinksSignature {
  Args: {
    direction: 'left' | 'right';
    show: boolean;
    toggle: () => void;
  };
  Blocks: {
    default: [];
  };
}

const TioQuicklinksComponent: TOC<TioQuicklinksSignature> = <template>
  <Button @appearance="minimal" {{on "click" @toggle}}>
    <PhDotsThreeVertical @size="20" />
  </Button>
  <div class="!inline-block !text-md !relative">
    {{#if @show}}
      <div class="!absolute bg-white z-5 !-top-4 !right-2">
        {{#if (eq @direction "right")}}
          <div {{onClickOutside @toggle}} class="!absolute shadow-xl !align-right !w-max">
            {{yield}}
          </div>
        {{else}}
          <div {{onClickOutside @toggle}} class="!absolute shadow-xl !align-left !w-max">
            {{yield}}
          </div>
        {{/if}}
      </div>
    {{/if}}
  </div>
</template>;

export default TioQuicklinksComponent;
